// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import { login, logout, getInfo } from "@/api/user";
import { setToken, removeToken } from "@/utils/auth";
import router, { resetRouter } from "@/router";
import Cookies from "js-cookie";

const state = {
  token: "",
  name: "",
  userInfo: {},
  avatar: "",
  introduction: "",
  roles: [],
  language: "",
  openStatus: false,
  permissions: [],
  printOptions: localStorage.getItem("printOptions")
    ? JSON.parse(localStorage.getItem("printOptions"))
    : [],
};

const mutations = {
  SET_TOKEN: (state, token) => {
    console.log(token, "11113132");
    state.token = token;
  },

  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction;
  },
  SET_NAME: (state, userInfo) => {
    state.userInfo = userInfo;
    state.name = userInfo.account;
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
    localStorage.setItem("roles", JSON.stringify(roles));
  },
  SET_LANGUAGE: (state, language) => {
    state.language = language;
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions;
  },
  SET_PRINTOPTIONS: (state, printOptions) => {
    state.printOptions = printOptions;
  },
  SET_OPENSTATE: (state, openStatus) => {
    state.openStatus = openStatus;
  },
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      login(userInfo)
        .then((data) => {
          commit("SET_TOKEN", data);
          localStorage.setItem("token", data);
          Cookies.set("JavaInfo", JSON.stringify(data));
          setToken(data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  loginData({ commit }, data) {
    return new Promise((resolve) => {
      commit("SET_TOKEN", data);
      localStorage.setItem("token", data);
      Cookies.set("JavaInfo", JSON.stringify(data));
      setToken(data);
      resolve();
    });
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token)
        .then((res) => {
          let data = res;
          commit("SET_NAME", data);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          commit("SET_TOKEN", "");
          commit("SET_ROLES", []);
          commit("SET_PERMISSIONS", []);
          removeToken();
          resetRouter();

          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit("SET_TOKEN", "");
      commit("SET_ROLES", []);
      removeToken();
      resolve();
    });
  },
  // 设置token
  setToken({ commit }, state) {
    return new Promise((resolve) => {
      commit("SET_TOKEN", state.token);
      Cookies.set("JavaInfo", JSON.stringify(state));
      setToken(data.token);
      resolve();
    });
  },

  // dynamically modify permissions
  changeRoles({ commit }, role) {
    return new Promise(async (resolve) => {
      commit("SET_ROLES", role);
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
